import { MouseEvent, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import * as constent from "util/constent";
import Button from "components/button/default";
import { useTranslation } from "react-i18next";
import "./alert.scss";

type IProps = {
  width?: number;
  height?: number;
  padding?: number;
};

export default function Alert({ width, height, padding }: IProps) {
  const { t } = useTranslation();
  const btnRef = useRef<HTMLButtonElement>(null);
  const cnlBtnRef = useRef<HTMLButtonElement>(null);

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [cncl_btn, setCnclBtn] = useState(false);
  const [chk_btn, setChkBtn] = useState(true);
  const [chk_text, setChkText] = useState(t("btn_vrf_cmm"));
  const [dplc, setDplc] = useState(false);
  const [keep, setKeep] = useState(false);
  const [inner, setInner] = useState("");
  const [innerHtml, setInnerHtml] = useState(null);

  const handleOpen = (e: any) => {
    const {
      isOpen,
      inner,
      cncl_btn,
      chk_btn,
      chk_text,
      dplc,
      innerHtml,
      click,
      cnlClick,
      keep,
    } = e.detail;

    setIsOpen(isOpen);
    !!inner && setInner(inner);
    setCnclBtn(cncl_btn);
    setChkBtn(chk_btn);
    setDplc(dplc);
    setKeep(keep);
    setInnerHtml(innerHtml);
    chk_text && setChkText(chk_text);

    setTimeout(() => {
      btnRef.current?.addEventListener("click", click);
      cnlBtnRef.current?.addEventListener("click", cnlClick);
    }, 100);
  };

  useEffect(() => {
    window.addEventListener(constent.CONST_COMM_ALERT_CONTROL, handleOpen);

    return () => {
      window.removeEventListener(constent.CONST_COMM_ALERT_CONTROL, handleOpen);
    };
  }, []);

  useEffect(() => {
    if (isOpen) {
      window.document.body.style.overflow = "hidden";
    }
    return () => {
      window.document.body.style.overflow = "auto";
    };
  }, [isOpen]);

  return (
    isOpen && (
      <section>
        {createPortal(
          <section className={"modal-layout" + " " + (dplc ? "dplc" : " ")}>
            <div
              className="modal alert max-w-96"
              size-width={width}
              size-height={height}
              size-padding={padding}
            >
              <h4 className="py-4 font-font-R text-center leading-6">
                {inner.length > 0 &&
                  inner.split("/").map((text, index) => {
                    return (
                      <p key={index} className="wrap-text">
                        {text}
                      </p>
                    );
                  })}

                {!!innerHtml && innerHtml}
              </h4>
              <div className="center gap-4 pt-2">
                {chk_btn && (
                  <Button
                    ref={btnRef}
                    text={chk_text}
                    styels=""
                    onClick={() => {
                      if (keep) {
                        return;
                      }
                      if (!keep) {
                        setIsOpen(false);
                        setInner("");
                        setInnerHtml(null);
                      }
                    }}
                  />
                )}
                {cncl_btn && (
                  <Button
                    ref={cnlBtnRef}
                    text={t("btn_ccl_cmm")}
                    styels="bg-white"
                    onClick={() => {
                      setIsOpen(false);
                    }}
                  />
                )}
              </div>
            </div>
          </section>,
          document.body
        )}
      </section>
    )
  );
}
